import React from "react";
import { observer } from "mobx-react-lite";
import UserStore from "stores/UserStore";
import "./Multipurchase.scss";
import Button from "components/Button/Button";
import PoolStore from "stores/PoolStore";

const multipliers = [
  { level: 1, p: "5" },
  { level: 2, p: "10" },
  { level: 3, p: "20" },
  { level: 4, p: "25" },
];

function Multipurchase({ pool, currentTab, currentLevel, boostCosts }) {
  const token = pool.multiplierTokens[currentTab];
  const balance = UserStore.balances.get(token.name);
  return (
    <div className="multipliers">
      {multipliers.map(({ level, p }, index) => {
        const bought = currentLevel >= level;
        const tooPoor = parseFloat(balance) < parseFloat(boostCosts[index]);
        return (
          <Button
            key={`${level}-${pool.id}-${token.name}`}
            className={`multiplier clickable ${token.name}-level ${bought && "bought"} ${tooPoor && "cannot-afford"}`}
            onClick={() => PoolStore.boost(pool, token, level)}
          >
            {!bought ? (
              <>
                <div className="multi-level">
                  LVL <b>{level}</b>
                </div>
                <div className="multi-boost">
                  BONUS <b>{p}%</b>
                </div>
                <div className="multi-cost">
                  COST <b>{boostCosts[index]}</b>
                </div>
              </>
            ) : (
              <div className="multi-bought">Bought! {p}%</div>
            )}
          </Button>
        );
      })}
    </div>
  );
}

export default observer(Multipurchase);
